const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*.()])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      user: {
        profile_id: null,
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        position: '',
        dealer_centre: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        role: 'seller',
        dealer_id: null,
        office_id: null,
        type: null,
        inn: '',
        companyName: '',
        urAddress: '',
        factAddress: '',
        offices: [],
        searchOffice: '',
      },
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      dialogCodeRules: false,
      code: '',
      codeRules: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        inn: v => !!v || 'Укажите ИНН',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
        companyName: v => !!v || 'Не задана компания, укажите ИНН',
      },
      valid: false,
      profile: {},
      searchPoint: '',
      searchAddress: '',
      pointName: null,
      suggestions: [],
      isLoadingSuggest: false,
      offices: [],
      points: [],
      addresses: [],
    };
  },
  watch: {
    'user.password': (value) => {
      const messageWrapper = document.getElementById('password_msg');
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      if (checkPassword.isEmpty) {
        return;
      }
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },
    // eslint-disable-next-line func-names,no-unused-vars
    'user.city_id': function (_) {
      this.pointName = null;
      this.user.dealer_id = null;
    },

    // eslint-disable-next-line func-names,no-unused-vars
    pointName(_) {
      this.user.dealer_id = null;
    },

    searchPoint(name) {
      const app = this;
      if (name && name.length) {
        app.user.city_id && app.$store.getters.ax.post('profiles/api/register/load-dealer-names', {
          city_id: app.user.city_id,
          name,
        })
          .then((result) => {
            app.points = result.data.names;
          });
      }
    },
    searchOffice(name) {
      name && this.$store.getters.ax.post('profiles/api/location/offices', { name })
        .then((result) => {
          this.offices = result.data.offices;
        });
    },

    searchAddress(address) {
      const app = this;
      const data = {};
      if (app.pointName) {
        data.name = app.pointName;
        data.city_id = app.user.city_id;
        if (address) {
          data.address = address;
        }
        this.$store.getters.ax.post('profiles/api/register/load-dealer-addresses', data)
          .then((result) => {
            this.addresses = result.data.addresses;
          });
      }
    },
    //  eslint-disable-next-line
    'user.inn': function (val) {
      this.user.companyName = '';
      this.user.urAddress = '';
      if (val && (val.length === 10 || val.length === 12)) {
        this.$store.getters.axl.post('profiles/api/dealers/find-by-inn', { inn_search: val, type_id: 1 })
          .then((result) => {
            const company = result.data.data[0];
            console.log(company);
            if (company) {
              this.company = company;
              this.user.companyName = company.organization_name;
              this.user.urAddress = company.address;
            }
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsNoProfile() { return this.type === 'sms_noprofile'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
            app.user.profile_id = profile.profile_id;
            app.user.office_id = profile.office_id;
          }
          if (profile && profile.dealer) {
            app.company = profile.dealer.name;
            app.user.inn = profile.dealer.inn;
            app.user.companyName = profile.dealer.name;
            app.user.urAddress = profile.dealer.address;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        dealer_id: '',
        role: 'seller',
        city_id: null,
        checkedRules: false,
        checkedPers: false,
        allow_push: false,

      };
      this.sentCode = false;
      this.sentCodeRules = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.cities = [];
      this.searchPoint = '';
      this.points = [];
      this.pointName = null;
      this.searchAddress = '';
      this.addresses = [];

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: app.type };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'profiles/api/profiles/get-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'profiles/api/profiles/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка проверочного СМС кода */
    SendCodeRules() {
      const app = this;
      const url = 'profiles/api/profiles/get-sms-rules';
      const data = { phone: app.user.phone };
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCodeRules = true;
          app.Focus('regCodeRules');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
          app.dialogCodeRules = false;
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCodeRules() {
      const app = this;
      const url = 'profiles/api/profiles/check-sms-rules';
      const data = { code: app.codeRules, phone: app.user.phone };
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          if (response) {
            this.dialogCodeRules = false;
            this.user.checkedRules = true;
            this.codeRules = '';
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCodeRules');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.token = app.token;
      formData.profile_id = null;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async GetObjects() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/location/offices')
        .then((result) => {
          app.offices = result.data.offices;
        });
    },
    ObjectChange(id) {
      const app = this;
      if (id) {
        app.$store.getters.axl.post('/profiles/api/rules/get-by-office', {
          office_id: id,
        })
          .then((res) => {
            app.user.checkedRules = false;
            app.pageRules = res.data.pageRules;
          });
      } else {
        app.pageRules = null;
        app.user.checkedRules = false;
      }
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
    this.GetObjects();
  },
};
